import { Tabs } from 'antd'
import React, { FunctionComponent } from 'react'

import { AUCTION_TYPES } from '../../common/auctionScrapeTypes'
import { AuctionDetailDrawer } from '../components/AuctionDetailDrawer/AuctionDetailDrawer'
import { AuctionMonitoringTab } from '../components/AuctionMonitoringTab/AuctionMonitoringTab'
import { PageLayout } from '../components/PageLayout/PageLayout'
import { PropertyDetailDrawer } from '../components/PropertyDetailDrawer/PropertyDetailDrawer'
import { PropertyMonitoringViewType } from '../components/PropertyMonitoringViewType/PropertyMonitoringViewType'
import { TabLabel } from '../components/TabLabel/TabLabel'
import { auctionTabSlug, tabsProps } from '../utils/tabsHelpers'
import { useTabKeyState } from '../utils/useTabKeyState'

const labelClassName = 'text-base text-center block w-28'
const tabItems = [
  {
    key: AUCTION_TYPES.BUILDING,
    label: <TabLabel title="Budovy" className={labelClassName} />,
    children: <AuctionMonitoringTab auctionType={AUCTION_TYPES.BUILDING} />,
  },
  {
    key: AUCTION_TYPES.AREA,
    label: <TabLabel title="Pozemky" className={labelClassName} />,
    children: <AuctionMonitoringTab auctionType={AUCTION_TYPES.AREA} />,
  },
  {
    key: AUCTION_TYPES.UNIT,
    label: <TabLabel title="Jednotky" className={labelClassName} />,
    children: <AuctionMonitoringTab auctionType={AUCTION_TYPES.UNIT} />,
  },
  {
    key: AUCTION_TYPES.UNKNOWN,
    label: <TabLabel title="Ostatní" className={labelClassName} />,
    children: <AuctionMonitoringTab auctionType={AUCTION_TYPES.UNKNOWN} />,
  },
]

export const AuctionMonitoring: FunctionComponent = () => {
  const [activeTabKey, setActiveTabKey] = useTabKeyState<AUCTION_TYPES>(
    AUCTION_TYPES.BUILDING,
    auctionTabSlug
  )

  return (
    <>
      <PageLayout title="Monitoring dražeb - výpis" isContainer>
        <Tabs
          {...tabsProps}
          items={tabItems}
          activeKey={activeTabKey}
          onTabClick={setActiveTabKey}
          tabBarExtraContent={<PropertyMonitoringViewType />}
        />
      </PageLayout>
      <AuctionDetailDrawer />
      <PropertyDetailDrawer />
    </>
  )
}

export default AuctionMonitoring
